export const transformKeyToTitle = (key: string) => {
    return key
        .replace(/(?<=[a-z0-9]|VPN|SSH|SS(?!H)|API)(?=[A-Z])/g, ' ')
        .replace(/_/g, ' ')
        .replace(/(?:^|_)([a-z])/g, (_, match) => match.toUpperCase());
};
